import { useState, useEffect, useRef } from 'react';
import Dropdown from './components/Dropdown';
import { searchContext } from '../../../context/Context';
import SearchButton from '../../../global/SearchButton/SearchButton';
import { SearchContext, SearchItem } from '../../../types';
import { useLocation } from 'react-router-dom';

const SearchBar = ({ placeholder }: { placeholder?: string }) => {
  const { searchItems, setSearchItems } = searchContext() as unknown as SearchContext;
  const [value, setValue] = useState('');
  const searchContainerRef = useRef<HTMLDivElement>(null);
  const location = useLocation();
  const isDropdownOpen = value.trim().length >= 3;

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const identsParam = params.get('idents');

    if (identsParam === 'ALL' && setSearchItems) {
      setSearchItems([]);
    }
  }, [location.search]);

  useEffect(() => {
    setValue('');
  }, [location.pathname, location.search]);

  useEffect(() => {
    if (!isDropdownOpen) return;
    const handleMouseDown = (e: MouseEvent) => {
      if (searchContainerRef.current && !searchContainerRef.current.contains(e.target as Node)) {
        setValue('');
      }
    };
    document.addEventListener('mousedown', handleMouseDown);
    return () => document.removeEventListener('mousedown', handleMouseDown);
  }, [isDropdownOpen]);

  useEffect(() => {
    if (isDropdownOpen) {
      document.body.classList.add('search-dropdown-open');
    } else {
      document.body.classList.remove('search-dropdown-open');
    }
    return () => document.body.classList.remove('search-dropdown-open');
  }, [isDropdownOpen]);

  return (
    <div className="row">
      <div
        ref={searchContainerRef}
        data-wow-delay="0.1s"
        className={`col-12 wow fadeIn ${isDropdownOpen ? 'search-dropdown-open' : ''}`}
      >
        <div className="search-input">
          <div id="app">
            <div className="search-dropdown-root">
              <div style={{ position: 'relative', display: 'inline-block', width: '100%' }}>
                <input
                  type="text"
                  autoComplete="off"
                  aria-autocomplete="list"
                  aria-controls="react-autowhatever-source"
                  placeholder={placeholder ?? 'Examples: Obesity,  LEPR,  rs121913279,  streptozocin...'}
                  value={value}
                  onChange={e => setValue(e.target.value)}
                />
                <div style={{ position: 'absolute', top: '50%', right: 0, transform: 'translateY(-50%)' }}>
                  <SearchButton
                    setValue={setValue}
                    className="first-button-class"
                    hasImg
                    imgSrc="../../static/images/button-1000x.png"
                  />
                </div>
              </div>
              {isDropdownOpen && (
                <div className="react-dropdown-wrapper">
                  <Dropdown
                    value={value}
                    setValue={setValue}
                    searchItems={searchItems as SearchItem[]}
                    setSearchItems={setSearchItems}
                    onDropdownToggle={() => {}}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchBar;
